import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import RadioGroup from '../../../../RadioGroup';
import { IRadioGroupOption } from '../../../../RadioGroup/types';
import { ISaveMeasureState } from './types';

interface IProps {
  strategyOptions: IRadioGroupOption[];
}

const StrategyOptions = styled(RadioGroup)`
  margin-top: 25px;
  margin-bottom: 25px;
`;

const SaveMeasureModalStrategy = ({ strategyOptions }: IProps) => {
  const { control } = useFormContext<ISaveMeasureState>();

  const { field } = useController({
    name: 'strategy',
    control,
  });

  const handleChange = (value: string) => {
    field.onChange(value);
  };

  return (
    <StrategyOptions
      name="strategy"
      value={field.value}
      onChange={handleChange}
      options={strategyOptions}
      hasPermissionCheck={true}
    />
  );
};

export default SaveMeasureModalStrategy;
